import React, { useState } from "react";

function AIHomePage(props) {
    const [query, setQuery] = useState("");
    const questions = require("../contents/questions.json");
    const quiz = questions[(props?.question || 1) - 1];
    const researchTopic = quiz.question;
    const backgroundImage = quiz.image
        ? `url('/image/${quiz.image}')`
        : "url('https://images.unsplash.com/photo-1736077722346-31ba59414728?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')";

    return (
        <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50">
            {/* Background Image with Fade */}
            <div className="absolute top-0 left-0 w-full h-2/5 bg-cover bg-center" style={{ backgroundImage }}>
                <div className="w-full h-full bg-gradient-to-b from-transparent to-gray-50"></div>
            </div>

            {/* Content Container */}
            <div className="relative flex flex-col items-center justify-center mt-20 max-w-6xl w-full">
                <div className="flex justify-start w-full mb-8 text-gray-600 font-medium text-lg">
                    <div className="mx-4">Generative X</div>
                </div>
                <h2 className="text-2xl font-semibold text-gray-700 mb-4 text-center max-w-4xl">Question {props.question}</h2>
                <h1 className="text-2xl font-bold text-gray-500 mb-8 text-center max-w-4xl">{researchTopic}</h1>
                <form onSubmit={() => props.handleSearch(query)} className="flex flex-col items-center w-full">
                    <div className="relative w-4/5 mb-4 border-0">
                        <div className="bg-gray-200 rounded-3xl flex flex-col pb-16">
                            <textarea
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                className="mx-5 mt-4 text-lg bg-transparent outline-none border-0 font-sans"
                                placeholder="Message Generative X"
                            />
                            <div className="absolute bottom-4 left-4 flex gap-2">
                                <button
                                    type="button"
                                    className="p-2 w-10 h-10 text-gray-500 hover:text-gray-700 transition-colors rounded-full"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <i className="fas fa-plus"></i>
                                </button>
                                <button
                                    type="button"
                                    className="p-2 h-10 flex items-center gap-1 text-gray-500 hover:text-gray-700 transition-colors rounded-full"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <i className="fas fa-globe"></i>
                                    <span className="text-sm">Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <button
                        type="submit"
                        disabled={query.length === 0}
                        className={`px-4 py-2 mb-10 text-lg text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                            query.length > 0 ? "bg-gray-700 hover:bg-gray-900" : "bg-gray-300 cursor-not-allowed"
                        }`}
                    >
                        Message Generative X
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AIHomePage;
